module.exports = __webpack_public_path__ + "static/media/facebookRounded.66654933.svg";